import React from "react";
import {observer} from "mobx-react";
import Snackbar from "@mui/material/Snackbar";
import { Alert } from '@mui/material'
import './modal.scss'
import {useStores} from "../../Hooks";
import {snackbarTypesEnum} from "../../enums";
import {Button, IconButton} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ActionSnackbar = observer(() => {
    const {modalStore} = useStores();

    function closeDialog(e, reason) {
        if (reason === 'clickaway') {
            return;
        }
        modalStore.isActionSnackBarOpen = false;
    }

    return (
        <Snackbar
            open={!!modalStore.isActionSnackBarOpen}
            autoHideDuration={7000}
            anchorOrigin={{vertical: 'top', horizontal: 'center'}}
            onClose={closeDialog}
        >
            <Alert severity={snackbarTypesEnum.INFO} className='action-snackbar'>
                <div className='action-snackbar-text'>{modalStore.actionSnackBarText}</div>
                <Button
                    variant='outlined'
                    className='cancel-primary-button'
                    onClick={modalStore.actionSnackBarCallback}
                >
                    {modalStore.actionSnackBarButtonText}
                </Button>
                <IconButton onClick={closeDialog}>
                    <CloseIcon/>
                </IconButton>
            </Alert>
        </Snackbar>
    )
});

export default ActionSnackbar;
